// extracted by mini-css-extract-plugin
export default {"footer":"MenuFooter-MenuFooter-module__footer--P9u3I"};